import { render, staticRenderFns } from "./SectionPointSelect.vue?vue&type=template&id=82dcda70"
import script from "./SectionPointSelect.vue?vue&type=script&lang=js"
export * from "./SectionPointSelect.vue?vue&type=script&lang=js"
import style0 from "./SectionPointSelect.vue?vue&type=style&index=0&id=82dcda70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports